import type { AppData } from "../domain/types";
// The production rollback reader accepts v2 and preserves unknown fields.
// Keep every v3 field; normalizeAppData restores the v3 in-memory model.
export function serializeAppData(data: AppData) { return JSON.stringify({ ...data, version: 2 }); }
